import styled from "styled-components";
import Typo, { TypoProps } from "../../atom/Typo";

interface BreakWordTypoProps extends TypoProps {}

const BreakWordTypo = (props: BreakWordTypoProps) => {
  return (
    <StyledWrapper>
      <Typo {...props} />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.span`
  word-break: break-all;
`;

export default BreakWordTypo;
